<div fxLayout="column">
    <mat-form-field fxFlex>
        <label>
            <select matNativeControl (change)="onChange($event.target['value'])">
                <option></option>
                @for (i of m_station; track i; let idx = $index) {
                    <option [value]="idx">{{ i.stat.$.name }}</option>
                }
            </select>
        </label>
    </mat-form-field>
    <app-station-snapshot></app-station-snapshot>
</div>
